import { Vue, Component, Prop } from "vue-property-decorator";
import md5 from 'md5';

function random(src: string, salt: string, a: number, b: number) {
  const r = parseInt(md5(`${src}+${salt}`).substring(0, 4), 16) / 0x10000
  return a + (b - a) * r
}

@Component
export default class extends Vue {
  @Prop({ required: true })
  id!: number

  @Prop({ default: 'LINE1' })
  line1!: string

  @Prop({ default: 'LINE2' })
  line2!: string

  @Prop({ default: 'red' })
  color!: string

  @Prop({ default: '' })
  seed!: string

  get transform() {
    return `rotate(${random(this.seed, 'rotate', - 20, 20)}deg) ` +
      `translate(${random(this.seed, 'translate-x', -15, 15)}%, ` +
      `${random(this.seed, 'translate-y', -15, 15)}%)`
  }

  get line1Style(): Partial<CSSStyleDeclaration> {
    const [left, top] = this.def.line1Pos
    const { color } = this.def
    return {
      color,
      top: `${top}px`,
      left: `${left}px`,
    }
  }

  get line2Style(): Partial<CSSStyleDeclaration> {
    const [left, top] = this.def.line2Pos
    const { color } = this.def
    return {
      color,
      top: `${top}px`,
      left: `${left}px`,
    }
  }

  get def() {
    const m = StampDef.members
    return m[this.id % m.length]
  }

  get imageUrl() {
    return this.def.imageUrl
  }

  get imageStyle(): Partial<CSSStyleDeclaration> {
    return {
      backgroundImage: `url('${this.imageUrl}')`,
    }
  }
}

class StampDef {
  constructor(
    readonly imageUrl: string,
    readonly color: string,
    readonly line1Pos: [number, number],
    readonly line2Pos: [number, number],
  ) {
  }

  static members: StampDef[] = []
}

StampDef.members.push(
  new StampDef(
    // tslint:disable-next-line: no-var-requires
    require('!file-loader!./stamp1.png'),
    '#3c478e',
    [100, 40],
    [100, 57],
  ),
  new StampDef(
    // tslint:disable-next-line: no-var-requires
    require('!file-loader!./stamp2.png'),
    '#a61010',
    [100, 50],
    [100, 70],
  ),
  new StampDef(
    // tslint:disable-next-line: no-var-requires
    require('!file-loader!./stamp3.png'),
    '#2d7b22',
    [100, 50],
    [100, 70],
  ),
)
